import { Container } from "reactstrap";
import styled from "styled-components";

export const ScholarshipsPageContainer = styled(Container)`
  margin-top: 6%;
  margin-bottom: 6%;
`;